import {
  formatAmount,
  formatPhoneEmail,
  formatPrice,
  validateOrderTimeRange,
} from '../futures/futuresOrderConstants';
import { inputDateTimeToQueryApi, toInputDateTime } from '../futures/futuresRoundConstants';

export const PERPETUAL_PAGE_SCENE = {
  ORDER: 'ORDER',
  ENTRUSTMENT: 'ENTRUSTMENT',
};

export const PERPETUAL_ORDER_STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'OPEN', label: '持倉中' },
  { value: 'CLOSED', label: '已平倉' },
  { value: 'LIQUIDATED', label: '已強平' },
];

export const PERPETUAL_ENTRUST_STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'PENDING', label: '委託中' },
  { value: 'CANCELLED', label: '已撤單' },
];

export const PERPETUAL_ORDER_STATUS_LABELS = {
  OPEN: '持倉中',
  PENDING: '委託中',
  CLOSED: '已平倉',
  CANCELLED: '已撤單',
  LIQUIDATED: '已強平',
};

export const PERPETUAL_ORDER_TREND_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'LONG', label: '做多' },
  { value: 'SHORT', label: '做空' },
];

export const PERPETUAL_ORDER_TREND_LABELS = {
  LONG: '做多',
  SHORT: '做空',
};

export const MEMBER_ROLE_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '正常帳號' },
  { value: '2', label: '試玩帳號' },
];

export const MEMBER_ROLE_LABELS = {
  1: '正常帳號',
  2: '試玩帳號',
  3: '測試帳號',
};

export function defaultPerpetualOrderTimeRange() {
  const now = new Date();
  const to = new Date(now);
  to.setHours(23, 59, 0, 0);

  const from = new Date(now);
  from.setDate(from.getDate() - 16);
  from.setHours(0, 0, 0, 0);

  return {
    orderTimeFromInput: toInputDateTime(from),
    orderTimeToInput: toInputDateTime(to),
  };
}

export function validatePerpetualOrderTimeRange(fromInput, toInput) {
  return validateOrderTimeRange(fromInput, toInput);
}

export function formatLeverage(contractMultiple) {
  if (contractMultiple == null || contractMultiple === '') {
    return '—';
  }
  const num = Number(contractMultiple);
  if (Number.isNaN(num)) {
    return '—';
  }
  return `${num % 1 === 0 ? num.toFixed(0) : num}倍`;
}

export function formatStakingDays(stakingTime) {
  if (stakingTime == null || stakingTime === '') {
    return '—';
  }
  const num = Number(stakingTime);
  if (Number.isNaN(num)) {
    return '—';
  }
  return `${num % 1 === 0 ? num.toFixed(0) : num}天`;
}

export function formatCloseTime(row) {
  if (row?.closeTime) {
    return row.closeTime;
  }
  if (row?.status === 'OPEN' || row?.status === 'PENDING') {
    return '未平倉';
  }
  return '—';
}

export function formatOptionalPrice(value, digits = 6) {
  if (value == null || value === '') {
    return '—';
  }
  return formatPrice(value, digits);
}

export function buildPerpetualOrderPageParams(pageNo, filters, pageScene) {
  const params = {
    pageNo,
    pageSize: 15,
    pageScene,
  };

  if (filters.status) {
    params.status = filters.status;
  }
  if (filters.orderType) {
    params.orderType = filters.orderType;
  }
  if (filters.roleId) {
    params.roleId = Number(filters.roleId);
  }

  const orderSerialId = filters.orderSerialId?.trim();
  if (orderSerialId) {
    params.orderSerialId = orderSerialId;
  }

  const memberIdsCsv = filters.memberIdsCsv?.trim();
  if (memberIdsCsv) {
    params.memberIdsCsv = memberIdsCsv;
  }

  const inviterId = filters.inviterId?.trim();
  if (inviterId) {
    params.inviterId = Number(inviterId);
  }

  const phoneEmail = filters.phoneEmail?.trim();
  if (phoneEmail) {
    params.phoneEmail = phoneEmail;
  }

  const orderTimeFrom = inputDateTimeToQueryApi(filters.orderTimeFromInput);
  const orderTimeTo = inputDateTimeToQueryApi(filters.orderTimeToInput);
  if (orderTimeFrom) {
    params.orderTimeFrom = orderTimeFrom;
  }
  if (orderTimeTo) {
    params.orderTimeTo = orderTimeTo;
  }

  const closeTimeFrom = inputDateTimeToQueryApi(filters.closeTimeFromInput);
  const closeTimeTo = inputDateTimeToQueryApi(filters.closeTimeToInput);
  if (closeTimeFrom) {
    params.closeTimeFrom = closeTimeFrom;
  }
  if (closeTimeTo) {
    params.closeTimeTo = closeTimeTo;
  }

  return params;
}

export { formatAmount, formatPhoneEmail, formatPrice };
